export default __webpack_public_path__ + "no-image-background.jpg";